var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cxm-ProgressLabelItem"},[_c('div',{style:(_vm.dotColor)}),_c("span",{tag:"Typography"},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }